
  var _styles = {
  "magicmember-expired-time": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  }
};



  module.exports = _styles;
  